<template>
  <div class="footer-wrap">
    <div class="t-1">办公地址:深圳市福田区华强广场酒店A座16HI</div>
    <div class="t-2">Copyright © 2003-2020 深圳市油柑科技有限公司版权所有 粤ICP备17093263号-1</div>
  </div>
</template>
<script>
export default {
  name: "MyFooter",
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.footer-wrap {
  overflow: hidden;
  width: 100%;
  min-width: 1200px;
  height: 140px;
  background-color: #383d51;
  .t-1 {
    margin: 40px 0 25px;
    font-size: 14px;
    text-align: center;
    color: #cdd6ee;
  }
  .t-2 {
    font-size: 14px;
    text-align: center;
    color: #cdd6ee;
  }
}
</style>